<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
      :title="page"
      :breadcrumbs="breadcrumbs"
      icon="mdi-react"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row justify="center" align="center">
<!--        <v-col cols="12" align="right">-->
<!--          <v-btn-->
<!--              color="primary"-->
<!--              align="right"-->
<!--              @click="openAdd"-->
<!--          >-->
<!--            Thêm nhãn hàng-->
<!--          </v-btn>-->
<!--        </v-col>-->
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="brands"
            :items-per-page="10"
            class="elevation-1"
          >
            <template v-slot:item.photo_url="{ item }">
              <img class="img-brand" :src="item.photo_url ? url + item.photo_url: require('@/assets/images/bi_image.png')" />
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)" v-if="hasPermissions('Update brand')">
                mdi-pencil
              </v-icon>
<!--              <v-icon small @click="deleteItem(item.id)">-->
<!--                mdi-delete-->
<!--              </v-icon>-->
            </template>
          </v-data-table>
        </v-col>

        <!-- open dialog -->
     
          <v-dialog
            v-if="brandDetail"
            v-model="dialog"
            persistent
            max-width="500px"
          >
            <v-card class="pa-4">
              <ValidationObserver ref="brandsedit">
                <v-card-title>
                  <span class="text-h5 mx-3">Sửa nhãn hàng</span>
                </v-card-title>
                <v-card-text>
                  <v-row justify="center" align="center">
                    <v-col cols="11">
                      <ValidationProvider  name="name"
                                           rules="required"
                                           v-slot="{ errors }">
                        <v-text-field
                            name="name"
                            background-color="#EDF2F7"
                            label="Tên"
                            v-model="brandDetail.name"
                            filled
                        ></v-text-field>
                        <span class="validate-error red--text">
                        {{ errors[0] }}
                      </span>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="11">
                      <v-file-input
                          label="Ảnh logo"
                          placeholder="Tải ảnh lên"
                          prepend-icon="mdi-camera"
                          @change="fileSelected"
                      ></v-file-input>
                      <v-img class="ml-8 img-brand" v-if="brandDetail" :src="url + src"></v-img>
                      <v-img class="ml-8 img-brand" :src=" src"></v-img>
                    </v-col>
                    <v-col cols="11" class="font-weight-bold">
                      Thông tin chăm sóc khách hàng
                    </v-col>
                    <v-col cols="11">
                      <ValidationProvider  name="work_time"
                                           rules="required"
                                           v-slot="{ errors }">
                        <v-text-field
                            name="work_time"
                            background-color="#EDF2F7"
                            label="Giờ bán hàng"
                            placeholder="Nhập giờ bán hàng (VD: 08:00 - 22:00)"
                            v-model="brandDetail.work_time"
                            filled
                        ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                   </span>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="11">
                      <ValidationProvider  name="phone"
                                           rules="required"
                                           v-slot="{ errors }">
                        <v-text-field
                            name="phone"
                            background-color="#EDF2F7"
                            label="SĐT bán hàng"
                            placeholder="Nhập SĐT (VD: 0961654535, 0987596959)"
                            v-model="brandDetail.phone"
                            filled
                        ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                   </span>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="11">
                      <ValidationProvider  name="phone_warranty"
                                           rules="required"
                                           v-slot="{ errors }">
                        <v-text-field
                            name="phone_warranty"
                            background-color="#EDF2F7"
                            label="SĐT bảo hành"
                            placeholder="Nhập SĐT"
                            v-model="brandDetail.phone_warranty"
                            filled
                        ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                   </span>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="11">
                      <ValidationProvider  name="phone_service"
                                           rules="required"
                                           v-slot="{ errors }">
                        <v-text-field
                            name="phone_service"
                            background-color="#EDF2F7"
                            label="SĐT than phiền dịch vụ"
                            placeholder="Nhập SĐT"
                            v-model="brandDetail.phone_service"
                            filled
                        ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                   </span>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-row justify="center" align="center">
                    <v-btn @click="dialog = false" class="mr-5"> HỦY </v-btn>
                    <v-btn color="primary" @click="save_brand()"> LƯU </v-btn>
                  </v-row>
                </v-card-actions>
              </ValidationObserver>
            </v-card>
          </v-dialog>

        <v-dialog
            v-model="dialogAdd"
            persistent
            max-width="500px"
        >
          <v-card class="pa-4">
            <ValidationObserver ref="brands">
              <v-card-title>
                <span class="text-h5 mx-3">Thêm nhãn hàng</span>
              </v-card-title>
              <v-card-text>
                <v-row justify="center" align="center">
                  <v-col cols="11">
                    <ValidationProvider  name="name"
                                         rules="required"
                                         v-slot="{ errors }">
                      <v-text-field
                          name="name"
                          background-color="#EDF2F7"
                          label="Tên"
                          v-model="brand.name"
                          filled
                      ></v-text-field>
                      <span class="validate-error red--text">
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="11">
                    <v-file-input
                        label="Ảnh logo"
                        placeholder="Tải ảnh lên"
                        prepend-icon="mdi-camera"
                        @change="fileSelected"
                    ></v-file-input>
                    <v-img class="ml-8 img-brand" :src=" src"></v-img>
                  </v-col>
                  <v-col cols="11" class="font-weight-bold">
                    Thông tin chăm sóc khách hàng
                  </v-col>
                  <v-col cols="11">
                    <ValidationProvider  name="work_time"
                                         rules="required"
                                         v-slot="{ errors }">
                      <v-text-field
                          name="work_time"
                          background-color="#EDF2F7"
                          label="Giờ bán hàng"
                          placeholder="Nhập giờ bán hàng (VD: 08:00 - 22:00)"
                          v-model="brand.work_time"
                          filled
                        ></v-text-field>
                          <span class="validate-error red--text">
                      {{ errors[0] }}
                     </span>
                      </ValidationProvider>
                    </v-col>
                    <v-col cols="11">
                      <ValidationProvider  name="phone"
                                           rules="required"
                                           v-slot="{ errors }">
                        <v-text-field
                          name="phone"
                          background-color="#EDF2F7"
                          label="SĐT bán hàng"
                          placeholder="Nhập SĐT (VD: 0961654535, 0987596959)"
                          v-model="brand.phone"
                          filled
                      ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                   </span>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="11">
                    <ValidationProvider  name="phone_warranty"
                                         rules="required"
                                         v-slot="{ errors }">
                      <v-text-field
                          name="phone_warranty"
                          background-color="#EDF2F7"
                          label="SĐT bảo hành"
                          placeholder="Nhập SĐT"
                          v-model="brand.phone_warranty"
                          filled
                      ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                   </span>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="11">
                    <ValidationProvider  name="phone_service"
                                         rules="required"
                                         v-slot="{ errors }">
                      <v-text-field
                          name="phone_service"
                          background-color="#EDF2F7"
                          label="SĐT than phiền dịch vụ"
                          placeholder="Nhập SĐT"
                          v-model="brand.phone_service"
                          filled
                      ></v-text-field>
                        <span class="validate-error red--text">
                    {{ errors[0] }}
                   </span>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-row justify="center" align="center">
                  <v-btn @click="dialogAdd = false" class="mr-5"> HỦY </v-btn>
                  <v-btn color="primary" @click="add_new"> THÊM MỚI </v-btn>
                </v-row>
              </v-card-actions>
            </ValidationObserver>
          </v-card>
        </v-dialog>
        </v-row>
    
    </v-container>
  </div>
</template>
<script>
import {
  GET_LIST_BRAND,
  GET_DETAIL_BRAND,
  UPLOAD_BRAND_IMAGE,
  UPDATE_BRAND,
  SAVE_BRAND,
  DELETE_BRAND
} from "@/store/modules/brand";
import { mapGetters } from "vuex";
import {
  ValidationProvider,
  ValidationObserver,
  localize
} from 'vee-validate/dist/vee-validate.full';

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      page: "Nhãn Hàng",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý nhãn hàng",
          disabled: true,
        },
      ],
      headers: [
        { text: "Tên nhãn hàng", value: "name", align: "start" },
        { text: "Logo", sortable: false, value: "photo_url", align: "center"},
        { text: "Actions", value: "actions", sortable: false },
      ],
      dialog: false,
      dialogAdd: false,
      src: "",
      image: {},
      hasImage: false,
      selectedFile: null,
      url:'',
      img1:true,
      img2:false,
      brand: {
        name:'',
        photo_url: null,
        work_time:'',
        phone: '',
        phone_warranty:'',
        phone_service:'',
        photo_url_path:null,
      },
    };
  },
  computed: {
    ...mapGetters({
      brands: "brands",
      brandDetail: "brandDetail",
    }),
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_LIST_BRAND);
  },
  mounted() {
    localize({
      vi: {
        names: {
          name:'Tên',
          phone:'SĐT',
          work_time: 'Giờ bán hàng',
          phone_warranty: 'SĐT bảo hành',
          phone_service:'SĐT dịch vụ',
        },
        messages: {
          required: '{_field_} ' +'không được bỏ trống!',
        },
      }
    });
    localize('vi');
  },
  watch: {
    brandDetail(val) {
      if (val && val.photo_url) {
        this.src = val.photo_url;
        this.img2 = false;
        console.log(this.img2);
      }
    },
  },
  methods: {
    fileSelected(event) {
      if (!event) {
        this.src = "";
        this.brandDetail.photo_url = "";
        this.brand.photo_url = "";
        this.img2= true;
      }
      this.img2= true;
      this.img1= false;
      this.image = event;
      this.src = URL.createObjectURL(this.image);
      if (this.image) {
        this.hasImage = !this.hasImage;
      }
      let formData = new FormData();
      formData.append("upload", this.image);
      formData.append("type", "brands");
      this.$store.dispatch(`${UPLOAD_BRAND_IMAGE}`, formData).then((data) => {
        this.brandDetail.photo_url = data.data.data[0].path;
        this.brand.photo_url = data.data.data[0].path;
      });
    },
    editItem(item) {
      this.$store.dispatch(`${GET_DETAIL_BRAND}`, item.id).then((data) => {
        if (data) {
          this.dialog = true;
        }
      });
    },
    openAdd() {
      this.dialogAdd = true
    },
    add_new() {
      let result = this.$refs.brands.validate()
      if(result) {
        if (!this.brand.name) {
          return false
        } else if (!this.brand.work_time) {
          return false
        }
        if (!this.brand.phone_warranty) {
          return false
        }
        if (!this.brand.phone_service) {
          return false
        } else {
          this.$store.dispatch(`${SAVE_BRAND}`, this.brand).then((data) => {
            if (data) {
              this.$toasted.success('Thêm mới thành công', {
                position: "top-center",
                theme: "toasted-primary",
                duration: 2000
              });
              this.dialogAdd = false;
              this.$store.dispatch(GET_LIST_BRAND);
            }
          });
        }
      }
    },
    deleteItem(id)
    {
      confirm('Bạn có chắc muốn xóa?') &&
      this.$store.dispatch(`${DELETE_BRAND}`,id).then(data=>{
        if(data && data.status === 1) {
          this.$store.dispatch(GET_LIST_BRAND);
        }
      })
    },
    save_brand() {
      let result = this.$refs.brandsedit.validate()
      if(result) {
        if (!this.brandDetail.name) {
          return false
        } else if (!this.brandDetail.work_time) {
          return false
        }
        if (!this.brandDetail.phone_warranty) {
          return false
        }
        if (!this.brandDetail.phone_service) {
          return false
        } else {
          this.$store.dispatch(`${UPDATE_BRAND}`, this.brandDetail).then((data) => {
            console.log(data.id);
            if (data) {
              this.$toasted.success('Cập nhật thành công', {
                position: "top-center",
                theme: "toasted-primary",
                duration: 2000
              });
              this.dialog = false;
              this.$store.dispatch(GET_LIST_BRAND);
            }
          });
        }
      }
    },
  },
};
</script>
<style lang="scss">
.img-brand {
  max-width: 100px;
  max-height: 100px;
  margin: auto;
  display: block;
}
</style>